import { useMemo } from 'react';
import {
  selectDeliveryDateTime,
  selectHospitalityCostCenter,
  selectHospitalityInstructions,
  selectOrderedHospitalityMenuItems,
  selectSpecialHospitalityItems
} from "./meeting-room-booking-dialog.duck";
import { useSelector } from "react-redux";

export function HasHospitalityInMeetingBooking(): boolean {
  const instructions = useSelector(selectHospitalityInstructions);
  const specialItems = useSelector(selectSpecialHospitalityItems);
  const orderedItems = useSelector(selectOrderedHospitalityMenuItems);
  const deliveryDateTime = useSelector(selectDeliveryDateTime);
  const costCenter = useSelector(selectHospitalityCostCenter);

  const retVal = useMemo(() => {
    return !!instructions || specialItems.length > 0 || orderedItems.length > 0 || !!deliveryDateTime || !!costCenter
  }, [instructions, specialItems, orderedItems, deliveryDateTime, costCenter]);
  return retVal;
}
